<template>
  <v-overlay class="custom-overlay-class" :value="$store.state.overlay.show">
    <v-progress-circular
        indeterminate
        size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "GlobalOverlay"
}
</script>

<style>
.custom-overlay-class {
  z-index: 10 !important;
}

</style>
